import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { InviteTeammate } from "@/components/team/InviteTeammate";

export function TeamPage() {
  return (
    <DashboardLayout>
      <div className="mb-8">
        <h1 className="text-3xl font-bold tracking-tight">Team</h1>
        <p className="mt-1 text-muted-foreground">
          Invite teammates to collaborate on your workspace.
        </p>
      </div>
      <InviteTeammate />
    </DashboardLayout>
  );
}
